import {
	Component,
	ContentChild,
	Input,
	TemplateRef
}                          from '@angular/core';
import { BaseComponent }   from '@core/bases/base-component/base.component';
import { fadeInOut }       from '@shared/animations/fadeInOut';
import {
	FileDropErrorIdEnum,
	FileDropTableColumnIdEnum,
	FileProcessConditionals,
	FileProcessStatusEnum,
	IFileDrop,
	IFileDropTableConfig
}                          from '@shared/components/file-drop/file-drop.model';
import { FileDropService } from '@shared/components/file-drop/file-drop.service';

@Component( {
	selector: 'app-file-drop-table[fileDropService]',
	templateUrl: './file-drop-table.component.html',
	styleUrls: [ './file-drop-table.component.scss' ],
	animations: [ fadeInOut ]
} )
export class FileDropTableComponent extends BaseComponent {

	private _fileDropService: FileDropService;
	fileDropTableColumnIdEnum = FileDropTableColumnIdEnum;
	fileDropErrorIdEnum = FileDropErrorIdEnum;
	fileProcessStatusEnum = FileProcessStatusEnum;

	@Input() set fileDropService( fileDropService: FileDropService ) {
		if ( !fileDropService || this._fileDropService ) { return; }
		this._fileDropService = fileDropService;
	}

	get fileDropService(): FileDropService {
		return this._fileDropService;
	}

	get fileProcessConditionals(): FileProcessConditionals {
		return this._fileDropService?.fileProcessConditionals;
	}

	get fileDropTableConfig(): IFileDropTableConfig {
		return this._fileDropService.fileDropConfig?.table;
	}

	get fileDropList(): IFileDrop[] {
		return this._fileDropService.fileDropList;
	}

	@Input() renderTableHeader = true;
	@Input() renderTableBody = true;

	@Input() hideTableHeader = false;
	@Input() hideTableBody = false;

	@Input() disableTableHeader = false;
	@Input() disableTableBody = false;

	@Input() styleClass: string;

	@ContentChild( 'tableHeaderItemTpl', { read: TemplateRef } ) tableHeaderItemTpl: TemplateRef<any>;
	@ContentChild( 'tableBodyItemTpl', { read: TemplateRef } ) tableBodyItemTpl: TemplateRef<any>;

	constructor() {
		super();
	}

	markFileDropItemAsDeleted( fileDropItemIndex: number ): void {
		this.fileDropService.markFileDropItemAsDeleted(
			fileDropItemIndex
		);
	}

	deleteInvalidItems(): void {
		this.fileDropService.deleteInvalidItems();
	}
}
